import { use } from "react";
import { ContainerContext } from "./container.context";
import { ContainerServicesList } from "src/shared/services/container/container.type";

export function useService<K extends keyof ContainerServicesList>(
    service: K
): ContainerServicesList[K] {
    const context = use(ContainerContext)[service];

    if (!context) throw new Error(`Container service "${service}" not found`);

    if (!service) throw new Error("Service name is required");

    return context;
}
